import { Input, Select, Checkbox, TextArea } from 'semantic-ui-react';
import { NewGroupFormContainer } from 'src/assets/styles/components/newGroupForm';
import { CcfFormLayout } from 'src/assets/styles/components/CcfForm';
import {
  eventSlugnameTrim,
  generateTimeArray,
  textArea,
  chPerm,
  kindgrouplist,
  isSeminarioKind,
  searchSelectProps,
} from 'src/components/helpers';
import { GENDER_OPTIONS } from 'src/components/helpers/guests/genderOptions';

const NewGroupForm = (props) => {
  const {
    inputs,
    categoriesgrouplist,
    comunidadProcess,
    weekdays,
    handleCheckers,
    loading,
    handleInputs,
    formSelect,
    errorInputs,
    selectHandle,
    isCouples,
    setInputs,
    editing,
    kindgroup,
  } = props;

  const selectHandleOnline = (a, { value, name }) => {
    if (value === 1) setInputs({ ...inputs, address: null, neighborhood: null, [name]: !!value });
    else selectHandle(a, { value, name });
  };
  const leaderGender = () => {
    if (inputs.gender) return inputs.gender;
    if (inputs.maleLeader && inputs.maleLeader.gender) return inputs.maleLeader.gender;
    if (inputs.femaleLeader && inputs.femaleLeader.gender) return inputs.femaleLeader.gender;
  };
  const onlineText = (online, address) => {
    if ((online && address) || online === 2) return 2;
    if (online) return 1;
    if (online === false) return 0;
  };

  const registrationInputClass = (name) =>
    `Registration__input Registration__input-${name} ${errorInputs[name] ? 'error' : ''}`;

  const isSeminario = isSeminarioKind(inputs.kindgroup || kindgroup);

  return (
    <NewGroupFormContainer>
      <div className="new-group-form__toggles">
        <div className="selectorCheck">
          <Checkbox
            label="¿Esta recibiendo personas?"
            name="status"
            checked={inputs.status}
            toggle
            className={`status ${errorInputs['status'] ? 'error' : ''}`}
            onClick={() => handleCheckers('status')}
          />
          <span>- {inputs.status ? 'Si' : 'No'}</span>
        </div>
        {!(inputs.activityName && inputs.activityName.includes('Parejas')) && !editing && (
          <div className="selectorCheck">
            <label className={inputs.coupleleadered ? '' : 'active-label'} htmlFor="coupleleadered">
              Un líder
            </label>
            <Checkbox
              label="Liderado en pareja"
              name="coupleleadered"
              id="coupleleadered"
              checked={inputs.coupleleadered}
              toggle
              className={`coupleleadered ${errorInputs['coupleleadered'] ? 'error' : ''}`}
              onClick={() => handleCheckers('coupleleadered')}
            />
          </div>
        )}
        {chPerm(['groups']) && (
          <div className="selectorCheck">
            <label className={inputs.suspended ? '' : 'active-label'} htmlFor="suspended">
              Activo
            </label>
            <Checkbox
              label="En suspensión"
              name="suspended"
              id="suspended"
              checked={inputs.suspended}
              toggle
              className={`suspended ${errorInputs['suspended'] ? 'error' : ''}`}
              onClick={() => handleCheckers('suspended')}
            />
          </div>
        )}
      </div>

      <CcfFormLayout className="ccf-form">
        <Select
          placeholder="Modalidad"
          className={registrationInputClass('online')}
          {...searchSelectProps({
            name: 'online',
            value: onlineText(inputs.online, inputs.address),
            handler: selectHandleOnline,
            options: ['Presencial', 'Solo Online', 'Alternancia'].map((t, i) => {
              return { key: i, value: i, text: t };
            }),
          })}
        />

        {formSelect({
          label: 'Tipo',
          name: 'kindgroup',
          value: inputs.kindgroup || kindgroup,
          errorInputs,
          disabled: !chPerm(['groups']),
          options: kindgrouplist,
        })}

        {formSelect({
          label: 'Categoría',
          name: 'activityName',
          value: inputs.activityName || '',
          errorInputs,
          disabled: categoriesgrouplist.length <= 0 || (isSeminario && !chPerm(['groups'])),
          options: categoriesgrouplist,
        })}

        <Select
          placeholder="Dia de la semana"
          className={registrationInputClass('dayOfWeek')}
          {...searchSelectProps({
            name: 'dayOfWeek',
            value: inputs.dayOfWeek,
            handler: selectHandle,
            options: weekdays.map((day, i) => {
              return { key: i, value: i, text: day };
            }),
          })}
        />
        <Select
          placeholder="Hora"
          loading={loading}
          className={registrationInputClass('time')}
          {...searchSelectProps({
            name: 'time',
            value: inputs.time ? inputs.time.substring(0, 5) : inputs.time,
            handler: selectHandle,
            options: generateTimeArray().map((a) => ({ key: a, value: a, text: a })),
          })}
        />
        {isSeminario && (
          <Input
            placeholder="Máximo de participantes"
            name="maxCapacity"
            value={inputs.maxCapacity}
            onChange={handleInputs}
            type="number"
            className={registrationInputClass('maxCapacity')}
          />
        )}
        {!isSeminario && (
          <Input
            placeholder="Nombre para identificar el grupo"
            name="groupName"
            value={inputs.groupName}
            onChange={handleInputs}
            className={registrationInputClass('groupName')}
          />
        )}
        {(!inputs.online || onlineText(inputs.online, inputs.address) === 2) && (
          <>
            <Input
              placeholder="Dirección del grupo"
              name="address"
              value={inputs.address}
              onChange={handleInputs}
              className={registrationInputClass('address')}
            />
            <Input
              placeholder="Barrio"
              name="neighborhood"
              value={inputs.neighborhood}
              onChange={handleInputs}
              className={registrationInputClass('neighborhood')}
            />
          </>
        )}
        {!isCouples &&
          formSelect({
            label: 'Genero del líder',
            name: 'gender',
            value: inputs.gender,
            errorInputs,
            options: GENDER_OPTIONS,
          })}

        <div className="ccf-form__observations">
          {textArea({
            TextArea,
            label: 'Escribe una observación de tu grupo',
            name: 'observations',
            value: inputs.observations,
            handler: handleInputs,
          })}
        </div>

        {(isCouples || leaderGender() === 'Masculino') && !isSeminario && (
          <div className="ccf-form__section">
            <h3>Información del líder</h3>
            <label htmlFor="maleCrecerlevel">
              {`Seleccione los pasos que ha realizado el líder ${isCouples ? 'hombre' : ''}`}
            </label>
            <Select
              search
              placeholder={`Seleccione los pasos que ha realizado el líder ${
                isCouples ? 'hombre' : ''
              }`}
              onChange={selectHandle}
              value={inputs.maleCrecerlevel || []}
              name="maleCrecerlevel"
              id="maleCrecerlevel"
              className={registrationInputClass('maleCrecerlevel')}
              fluid
              multiple
              selection
              options={comunidadProcess.map((opt) => {
                return { key: opt, value: opt, text: eventSlugnameTrim(opt) };
              })}
            />
            <label htmlFor="maleLeader">Lider de el líder</label>
            <div className="ccf-form__leader-fields">
              <Input
                placeholder="Nombre del líder"
                name="maleLeaderFullName"
                value={inputs.maleLeaderFullName}
                defaultValue={inputs?.maleLeader?.GuestLeader?.leaderFullName}
                onChange={handleInputs}
                className={registrationInputClass('maleLeaderFullName')}
              />
              <Input
                placeholder="Teléfono del líder"
                name="maleLeaderPhone"
                value={inputs.maleLeaderPhone}
                defaultValue={inputs?.maleLeader?.GuestLeader?.leaderPhone}
                onChange={handleInputs}
                className={registrationInputClass('maleLeaderPhone')}
              />
            </div>
          </div>
        )}

        {(isCouples || leaderGender() === 'Femenino') && !isSeminario && (
          <div className="ccf-form__section">
            <h3>Información de la líder</h3>
            <label htmlFor="femaleCrecerlevel">
              {`Seleccione los pasos que ha realizado la líder ${isCouples ? 'mujer' : ''}`}
            </label>
            <Select
              search
              placeholder={`Seleccione los pasos que ha realizado la líder ${
                isCouples ? 'mujer' : ''
              }`}
              onChange={selectHandle}
              value={inputs.femaleCrecerlevel || []}
              name="femaleCrecerlevel"
              id="femaleCrecerlevel"
              className={registrationInputClass('femaleCrecerlevel')}
              fluid
              multiple
              selection
              options={comunidadProcess.map((opt) => {
                return { key: opt, value: opt, text: eventSlugnameTrim(opt) };
              })}
            />
            <label htmlFor="femaleLeader">Lider de la líder</label>
            <div className="ccf-form__leader-fields">
              <Input
                placeholder="Nombre del líder"
                name="femaleLeaderFullName"
                value={inputs.femaleLeaderFullName}
                defaultValue={inputs?.femaleLeader?.GuestLeader?.leaderFullName}
                onChange={handleInputs}
                className={registrationInputClass('femaleLeaderFullName')}
              />
              <Input
                placeholder="Teléfono del líder"
                name="femaleLeaderPhone"
                value={inputs.femaleLeaderPhone}
                defaultValue={inputs?.femaleLeader?.GuestLeader?.leaderPhone}
                onChange={handleInputs}
                className={registrationInputClass('femaleLeaderPhone')}
              />
            </div>
          </div>
        )}
      </CcfFormLayout>
    </NewGroupFormContainer>
  );
};

export default NewGroupForm;
